
<template>

  <div class="cookie-foot" :style="{'flex-direction': $screen.breakpoint === 'sm' ? 'column' : 'row', 'height': $screen.breakpoint === 'sm' ? '210px' : '80px'}">
    <div class="cookie-content" :style="{'justify-content': $screen.breakpoint === 'sm' ? 'flex-start' : 'center', 'height': $screen.breakpoint === 'sm' ? '30%' : '100%'}">
      <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/cookieWhite.png" v-if="$screen.breakpoint !== 'sm'"/>
      <p>
        We use cookies to improve your experience on our site and to show you relevant issues related to the buildings and equipment you monitor with BreeziPro. Please close this window to accept our use of cookies. To learn more, please read our <a style="color:#2698dd;cursor:pointer;" @click="navPriv">Privacy Policy</a>.
      </p>
    </div>
    <div class="close-cookie" @click="acceptCookie">
      <a @click="acceptCookie">Accept<br />and Close</a>
    </div>
  </div>

</template>

<script>

export default {

  data(){
    return {

    }
  },

  methods: {

    navPriv(){
      window.location = 'https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/Privacy.pdf';
    },

    acceptCookie(){
      this.$cookies.set('breeziProAcceptCookies', true, Infinity);
      this.$store.dispatch('setCookieToState', true);
      this.$emit('setCookie');
    }

  }

}

</script>

<style>

.cookie-foot {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 80px;
  background: #64318d;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cookie-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.cookie-foot img {
  height: 75%;
}

.cookie-foot p {
  font-size: .65em;
  width:350px;
  margin: 0 20px 0 20px;
}

.close-cookie {
  width: 90px;
  height: 50px;
  border: 1px solid white;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: .9em;
  cursor: pointer;
}

.close-cookie:hover {
  background-color: white;
  color: #64318d;
  margin: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/util/Cookies.vue